import React, { useState, useEffect } from 'react';
import { Card, Form } from '@deere/ux.uxframe-react'
import Table from '../../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { updateSurveyAnswers } from '../../redux/action/surveyAction';
import {  EMPTY_BODY, SCBM_SECCIO_CODES } from '../../utils/surveyLiterals'
import { findAnswerIndex, getTranslation } from '../../utils/utils';
import store from '../../redux/store'
import { useTranslation } from "react-i18next";
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';
import RadioGroup from '../../components/RadioGroup';

export default function BusinessSegmentationPage({ survey }) {

    const { t } = useTranslation();
    const dispatch = useDispatch()
    const [checkSection, setCheckSection] = useState("")
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([])
    const section = survey.sections.find(e => e.code === SCBM_SECCIO_CODES.BS && e.active);    
    const questions = section && section.questions ? section.questions :null 
    
    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyResponse])

    if (!survey) return EMPTY_BODY;

    const updateAnswer = (e, questionId) => {
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target.value }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function createRadioSection(question) {
        return (<>
                <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <div><RadioGroup key={1} rgIndex={1} radioLabels={question ? question.selections : []}
                        updateAnswer={updateAnswer} question={question}
                        defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                        section={getTranslation(section, 'description')}
                        checkedProprietary={checkSection}/>
                    </div>                        
                </Form.Group>
             </>)
    }

     function createDependencyTextArea(question) {
        let shouldRender = true;
        if (question && question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            if (qIndex === -1 || (qIndex >= 0 && answers[qIndex].answer !== question.idSelectionDependson.toString())) {
                shouldRender = false;
            }
        }
        return( shouldRender ? <> 
            <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
            <DebounceInput
                element="textarea"
                className="form-control"
                onChange={(e) => updateAnswer(e,question.id)}
                debounceTimeout={300}
                value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                name={`${getTranslation(section, 'description')}-${question.id}`}
                required={question.required}/>
            <div className="invalid-feedback">
                {t('bs_required')}
            </div>
        </> : null)
    }
    function createOption(question){
        return (<>
                <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <Form.Control as='select' required={!checkSection} className="custom-select" onChange={(e) => updateAnswer(e, question.id)}
                        value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                        name={getTranslation(section, 'description')+'-'+question.id}>
                        <option value=''>{t('lbl_dropdown_select')}</option>
                        {question.selections ? question.selections.sort((a, b) => (parseInt(a.value) > parseInt(b.value)) ? 1 : -1).map(opt => <option key={opt.id} value={opt.value}>{getTranslation(opt, 'text')}</option>) : null}
                    </Form.Control>
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                </Form.Group>
                </>)
    }


    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}                    
                </Card.Title>                                              
                <>
                    {
                        <>
                            {            
                              questions && questions.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((q,index) =>

                                    <div key={index}>
                                        <Form.Row className={q.idQuestionDepends ? 'd-block mb-4 pl-4' : "d-block mb-4"}>
                                            {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                                            {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createDependencyTextArea(q) : <></>}
                                            {q.type === 'OPTION' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createOption(q) : <></>}
                                        </Form.Row>
                                    </div>
                                )
                            }
                        </>
                    }
                </>
                <Table section={section} questions={questions} updateAnswer={updateAnswer} answers={answers} checkedProprietary={checkSection} isTotal={true}/>
            </Card.Body>
        </Card>        
    </>)
}